// src/components/charts/AuditStatusChart.tsx
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Audit } from '../../types';

type ApexOptions = any;

interface AuditStatusChartProps {
  audits: Audit[];
}

const AuditStatusChart: React.FC<AuditStatusChartProps> = ({ audits }) => {
  // Agrupar auditorías por estado
  const statusCount = audits.reduce((acc, audit) => {
    acc[audit.status] = (acc[audit.status] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const statusLabels = {
    'pending': 'Pendiente',
    'in-progress': 'En Progreso',
    'completed': 'Completada',
  };

  const labels = Object.keys(statusCount).map(status => statusLabels[status as keyof typeof statusLabels]);
  const data = Object.values(statusCount);

  const options: ApexOptions = {
    chart: {
      type: 'pie',
    },
    labels: labels,
    colors: ['#faad14', '#1890ff', '#52c41a'],
    legend: {
      position: 'bottom',
    },
    title: {
      text: 'Estado de Auditorías',
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} auditoría${val !== 1 ? 's' : ''}`,
      },
    },
  };

  return <ReactApexChart options={options} series={data} type="pie" height={300} />;
};

export default AuditStatusChart;
